
  const card = document.querySelector('.hero-right');
  const image = document.querySelector('.website-preview');

  /* 🔥 Disable animation on mobile */
  if (window.innerWidth < 968) {
    card.style.pointerEvents = 'none'; // No mouse movement
    image.style.transform = 'none'; // Remove 3D effect
  }

  /* Desktop hover animation */
  card.addEventListener('mousemove', (e) => {
    if (window.innerWidth < 968) return; // Prevent on mobile

    const rect = card.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const rotateY = (x / rect.width - 0.5) * 10;
    const rotateX = (y / rect.height - 0.5) * -10;

    image.style.transform = `rotateY(${rotateY}deg) rotateX(${rotateX}deg) scale(1.03)`;
  });

  card.addEventListener('mouseleave', () => {
    if (window.innerWidth < 968) return; // Prevent on mobile

    image.style.transform = 'rotateY(-5deg) rotateX(6deg)';
  });

  
